// extracted by mini-css-extract-plugin
export default {"button":"Al-z","reviewSort":"Bl-z"};